import { createSlice } from '@reduxjs/toolkit';
import { fetchApplicationDetailsThunk } from '@/modules/candidate/store/applicationDetails.thunk';
import type { ApplicationDetailsState } from '@/modules/candidate/types/candidateApplication.types';

const initialState: ApplicationDetailsState = {
  data: null,
  loading: false,
  error: null,
};

const applicationDetailsSlice = createSlice({
  name: 'applicationDetails',
  initialState,
  reducers: {
    clearApplicationDetails(state) {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApplicationDetailsThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApplicationDetailsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchApplicationDetailsThunk.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch application details.';
      });
  },
});

export const { clearApplicationDetails } = applicationDetailsSlice.actions;
export default applicationDetailsSlice.reducer;